import PropTypes from 'prop-types';
import React from 'react';
import { ChatbotProvider } from '../../../hooks/ChatbotContext';
import './BaseChatbotWidget.scss';
import ChatbotWidgetCore from './ChatbotWidgetCore';

/**
 * Chatbot widget that provides Context wrapper for the chatbot functionality
 */
function ChatbotWidget({ initialState, ...props }) {
  return (
    <ChatbotProvider initialState={initialState}>
      <ChatbotWidgetCore {...props} />
    </ChatbotProvider>
  );
}

ChatbotWidget.propTypes = {
  chatService: PropTypes.object,
  emptyStateTitle: PropTypes.string,
  emptyStateText: PropTypes.string,
  historyButtonLabel: PropTypes.string,
  buttonIconName: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  getChatContextData: PropTypes.func,
  animationDuration: PropTypes.number,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  isControlled: PropTypes.bool,
  isOpenControlled: PropTypes.bool,
  focusOnOpen: PropTypes.bool,
  practicePageUrls: PropTypes.array,
  initialState: PropTypes.object,
  hideFloatingButton: PropTypes.bool,
};

ChatbotWidget.defaultProps = {
  emptyStateTitle: 'AI Assistant',
  emptyStateText: 'Ask me anything about your course, lessons, or any other questions you might have.',
  historyButtonLabel: '📜 History',
  buttonIconName: 'chat',
  errorMessage: 'An error occurred. Please try again.',
  className: '',
  chatService: null,
  children: null,
  animationDuration: 500,
  onOpen: null,
  onClose: null,
  isControlled: false,
  isOpenControlled: undefined,
  focusOnOpen: true,
  initialState: null,
};

export default ChatbotWidget;
